// extracted by mini-css-extract-plugin
module.exports = {"item":"P_cQ","item__image":"P_cR"};